import { render, staticRenderFns } from "./RichClient.vue?vue&type=template&id=a602056c&scoped=true&"
import script from "./RichClient.vue?vue&type=script&lang=js&"
export * from "./RichClient.vue?vue&type=script&lang=js&"
import style0 from "./RichClient.vue?vue&type=style&index=0&id=a602056c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a602056c",
  null
  
)

export default component.exports